import React from 'react';
import PropType from 'prop-types';
import YoutubeVideoEmbed from 'epic-react-common/src/components/YoutubeVideoEmbed';
import root from 'window-or-global';

export default class VideoOverlay extends React.Component {
    static propTypes = {
        video: PropType.string,
        showOverlay: PropType.bool,
        closeOverlay: PropType.func
    };

    state= {
        play: false
    };

    componentDidMount() {
        this.fadeIn();
    }

    componentWillUnmount() {
        this.stopVideo();
    }

    fadeIn = () => {
        if (this.props.showOverlay && !this.state.play) {
            const el = this.overlay;
            const {video} = this;
            TweenMax.fromTo(el, 1, {autoAlpha: 0}, {autoAlpha: 1, force3D: true, ease: Power1.easeOut});
            TweenMax.fromTo(video, 1, {scale: 0.5, autoAlpha: 0}, {
                scale: 1, autoAlpha: 1, delay: 1, force3D: true, ease: Power3.easeOut, onComplete: this.playVideo
            });
        }
    };

    playVideo = () => {
        this.setState({play: true});
    };
    stopVideo = () => {
        this.setState({play: false});
    };

    videoOptions = {
        playerVars: {
            width: '100%',
            height: '100%',
            showinfo: 0,
            controls: 1,
            autohide: 0,
            cc_load_policy: 0,
            disablekb: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            rel: 0,
            loop: 0
        }
    };

    render() {
        let disableAutoPlay = false; //auto play on mobile browsers can behave badly. Need to make This a store.
        try {
            disableAutoPlay = root._epicGamesNav.browser.mobile || root._epicGamesNav.browser.tablet;
        } catch (e) {
            console.error('Failed to read mobile and tablet bool from browser');
        }
        const {video, closeOverlay} = this.props;

        return (
            <div role="presentation" ref={(c) => {this.overlay = c;}} className="video-overlay" onClick={closeOverlay}>
                <div className="container vidContainer">
                    <div ref={(c) => {this.video = c;}} className="video embed-responsive embed-responsive-16by9">
                        <YoutubeVideoEmbed
                            video={video}
                            videoOptions={this.videoOptions}
                            mute={false}
                            loop={true}
                            play={disableAutoPlay ? false : this.state.play} />
                    </div>
                </div>
            </div>
        );
    }
}

